export const BUTTONS = {
    SUBMIT: "Submit",
    SEARCH: "Search",
    RESET: "Reset",
    REMOVE: "Remove",
    SAVE: "Save",
    SAVE_DRAFT: "Save Draft",
    SAVE_DOCUMENT_NAME: "Save Name",
    SAVING: "Saving...",
    SAVE_AND_CONTINUE: "Save & Activate",
    VALIDATE: "Validate Content",
    VALIDATING: "Validating...",
    CLOSE: "Close",
    SEND: "SEND",

    SENDING: "SENDING",
    CONTINUE: "CONTINUE",
    ADD: "Add",
    ADDING: "Adding...",
    CANCEL: "Cancel",
    VERIFY: "Verify",
    VERIFYING: "VERIFYING...",
    LOADING: "Loading",
    SEND_REQUEST: "Send Request"
};

export const MESSAGE = {
    MAX_VALUE_REACHED: "Maximum number of items reached.",
    MAX_PAGE_REACHED: "Maximum 10 pages are allowed",
    MIN_PAGE_REACHED: "Minimum 1 pages are allowed",
    SAVED: "Data Saved Successfully",
    VALIDATED: "Validated successfully",
    REQUEST_ACCESS: "To proceed, we need the candidate’s consent to disclose their information.\nThe candidate will receive a notification via message or email requesting their authorization.",
    DRAFT_SAVED: "Draft Saved Successfully",
    SAVED_LOCALLY: "Your changes are not saved. please SAVE to avoid data loss.",
    DEFAULT_ERROR_MESSAGE: "Something went wrong. Please try again later",
    INVALID_TAG: "The Tags [{0}] are invalid",
    TAG_LEFT: "The tags [{0}] are missing",
    COULD_NOT_ACTIVATE: " Document is still in draft.",
    DOCUMENT_ALREADY_ISSUED: "Document already Issued",
    SELECT_SUPPORT_DOCUMENT_DROPDOWN: "No Document Required",
    NO_DATA_TO_SAVE: "Please add some data to proceed",
    REQUEST_SENT: 'Added to cart successfully',
    DEFAULT_ERROR_MESSAGE: 'Something Went Wrong, please try again',
    PLACEHOLDER: 'Start typing...',
    QR_LENGTH_REACHED:"You cannot add more than one QR"
};

export const LAYOUT_TEXT = {
    ADD_MORE_PAGE: "+ Pg",
    REMOVE_PAGE: "- Pg",
    ADD_TO_DESIGN: "+ Add to Design",
    INSERT_TAGS: "Insert Tags",
    EDITOR_HEADING: "Select any component to start editing"
}

export const TITLE = {
    Home: "Home",
    Profile: "Profile",
    Layout: "Layout"
}

export const STATUS = {
    CREATED: "Created",
    DROPPED: "Marked Dropped",
    ACTIVATED: "Activate",
    DEACTIVATED: "de-activate",
    DRAFT: "Draft",
    PENDING: "Pending",
    COMPLETED: "Completed",
    ISSUED: "Issued",
    DONE: "Done",
    REVOKED: "Revoked",

    DOCUMENT_CREATED: "DOCUMENT_CREATED",
    TAG_MAPPING: "TAG_MAPPING",
    DESIGN: "DESIGN",
    UNCONFIRMED: "UNCONFIRMED",
    INACTIVE: "INACTIVE",
    ISSUED: "Issued",
    ACTIVE: "ACTIVE"
}

export const APP_NAME = 'AuthNumber'

export const CONSENT = {
    PAGE_TITLE: "Consent Request",
    HEADING: "Consent for sharing your information",
    SUB_HEADING: "{0} has requested your permission to access and verify the information listed below.",
    SUB_HEADING_FALLBACK: "An organisation has requested your permission to access and verify the information listed below.",
    REQUESTED_FROM: "Requested from",
    REQUESTED_BY: "Requested by",
    PURPOSE: "Purpose of this request",
    DATA_REQUESTED: "Information requested",
    NO_DATA_REQUESTED: "No specific information has been listed in this request.",
    DECLARATION: "Declaration",
    /* Labels the adapter and the page used to hardcode. */
    META: { REQUESTED_ON: "Requested on", VALID_TILL: "Valid till" },
    FIELD: { NAME: "Name", EMAIL: "Email", MOBILE: "Mobile" },
    CHECKS_HEADING: "Verification checks included",
    NOTICE_UNAVAILABLE: "The consent notice could not be loaded. Please ask the requesting organisation for a new link.",
    NOTICE_VERSION: "Notice {0} · last updated {1}",
    /* Keyed by the backend's own column key, so an unlisted column still gets a
       readable header from formatText() and a proper one costs one line here. */
    TABLE_COLUMNS: {
        category: "Category",
        data_elements: "Data collected",
        purpose: "Purpose",
        usage: "How it is used",
        consent: "Your consent"
    },
    TABLE_EMPTY: "No data categories are listed in this notice.",
    REQUIRED_TAG: "Required",
    OPTIONAL_TAG: "Optional",
    CONSENT_LABEL: "I consent",
    PURPOSE_CHECK_ARIA: "I consent to: {0}",
    ACK_CHECK_ARIA: "I confirm: {0}",
    CONSENT_REQUIRED: "Please tick every required consent and confirmation before accepting.",
    CONSENT_PENDING_HINT: "{0} required consent(s) still to tick before you can accept.",
    DEFAULT_DECLARATION: "I confirm that I have read and understood this request, and I voluntarily authorise the sharing of the information listed above with the requesting organisation for the stated purpose.",
    AGREE_LABEL: "I have read and agree to the declaration above.",
    AGREE_REQUIRED: "Please accept the declaration to continue.",
    APPROVE: "Accept & Continue",
    REJECT: "Decline",
    OTP_HEADING: "Verify to record your response",
    OTP_SUB_HEADING: "Enter the 6-digit OTP sent to {0} to confirm your decision.",
    OTP_SUB_HEADING_FALLBACK: "Enter the 6-digit OTP sent to your registered contact to confirm your decision.",
    OTP_SENT: "OTP sent successfully",
    OTP_FAILED: "Could not send OTP. Please try again.",
    OTP_REQUIRED: "Please enter the 6-digit OTP",
    CONFIRM_APPROVE: "Confirm Acceptance",
    CONFIRM_REJECT: "Confirm Decline",
    VERIFYING: "Verifying...",
    BACK: "Back",
    APPROVED_TITLE: "Consent recorded",
    APPROVED_BODY: "Thank you. Your consent has been recorded and the requesting organisation has been notified. You may close this window.",
    REJECTED_TITLE: "Consent declined",
    REJECTED_BODY: "Your decision has been recorded and the requesting organisation has been notified. You may close this window.",
    ALREADY_DONE_TITLE: "Already responded",
    ALREADY_DONE_BODY: "A response has already been recorded for this consent request.",
    EXPIRED_TITLE: "Link expired",
    EXPIRED_BODY: "This consent link is no longer valid. Please ask the requesting organisation to send a new request.",
    INVALID_TITLE: "Invalid link",
    INVALID_BODY: "We could not find a consent request for this link. Please check the link you received or request a new one.",
    LOADING: "Loading your consent request...",
    RETRY: "Try again",
    SECURED_BY: "Secured by"
}
